<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-image">
        <div class="prop-1-1">
          <template v-for="tag in item.tags">
            <template v-if="tag.id == 290">
              <div class="dealTag">
                {{ tag.names.name }}
              </div>
            </template>
          </template>
          <slot name="item-image">
            <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                     :alt="item | itemName"
                                     :title="item | itemName"
                                     :item-url="item | itemURL(urlWithVariationId)"
                                     :enable-carousel="$ceres.config.item.enableImageCarousel"
                                     :disable-carousel-on-mobile="disableCarouselOnMobile"
                                     ref="categoryImageCarousel">
            </category-image-carousel>
          </slot>
        </div>
        <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value">
          <div class="item-special-icon reduced">
            %
          </div>
        </template>
        <template v-if="catIcons.length > 0">
          <div class="item-characters d-flex">
            <div class="character" v-for="varProps in catIcons">
              <template v-if="varProps.selectionId == 1503">
                <img src="https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_schwerentflammbar.gif" title="schwerentflammbar" alt="schwerentflammbar" loading="lazy" >
              </template>
              <template v-if="varProps.selectionId == 1506">
                <img src="https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_aussen_innen.gif" title="aussenanwendung" alt="fuer aussenanwendung" loading="lazy" >
              </template>
            </div>
          </div>
        </template>
        <template v-if="hundredYears">
          <img :alt="'100 years'" :src="'https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/100Jahre_Icon_'+ lang.toUpperCase() +'.png'" loading="lazy" class="new-badge">
        </template>
        <template v-if="item.item.storeSpecial != null">
          <!-- topseller bild link-->
          <img :alt="'topseller'" :src="'https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/topseller/Icon_Topseller_'+ lang.toUpperCase() +'.png'" loading="lazy" class="new-badge" v-if="item.item.storeSpecial.id == 3" >
        </template>
        <template v-if="item.item.storeSpecial != null">
          <img :alt="'neuheiten'" :src="'https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/neuheiten/icon_neu_'+lang+'.png'" class="new-badge" loading="lazy" v-if="item.item.storeSpecial && item.item.storeSpecial.id == 2">
        </template>
      </div>

      <!-- STORE SPECIALS -->
      <slot name="store-special" v-if="item.item.storeSpecial  != null">
        <item-store-special v-if="(storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set') && item.item.storeSpecial.id !== 3"
                            :store-special="storeSpecial"
                            :recommended-retail-price="item.prices.rrp"
                            :variation-retail-price="item.prices.default"
                            :special-offer-price="item.prices.specialOffer"
                            :decimal-count="decimalCount"
                            :bundle-type="item.variation.bundleType"
                            :item-type="item.item.itemType">
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content">
          <a :aria-label="item.texts.name1" :href="item | itemURL(showVars)" class="thumb-title" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
            <span class="title-shrink">
              {{ item | itemName }}<!--
              --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
            </span>
                        <p v-if="combinedPropertiesString !== ''" class="text-center mt-2" style="color:black;font-size:14px">
                          {{ combinedPropertiesString }}
                        </p>
            <span class="cat-avail" :class="'availability-'+item.variation.availability.id">
              {{ item.variation.availability.names.name }}
              <template v-if="zulauf">
                <br>
                {{ zulauf }}
              </template>
            </span>
            <div class="var-count">
              <template v-if="item.item.salableVariationCount > 1">
                <div>
                  <span>{{ $translate('Woerner::Template.variationsCat') }} <i class="fa fa-caret-right ml-1"></i></span>
                </div>
              </template>
            </div>
          </a>
          <div class="thumb-meta mt-2">
            <slot name="before-prices"></slot>

            <div class="prices">
              <div class="price" :class="{'darkgreen': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value}">
                <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value">
                  <del class="crossprice" v-if="item.prices.specialOffer">
                    {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                  </del>
                  <del class="crossprice" v-else>
                    {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                  </del>
                  <br class="d-inline-block d-md-none">
                </template>
                <template v-if="item.item.itemType === 'set'">
                  {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}
                </template>
                <template v-else-if="itemGraduatedPriceisCheapestSorting">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
                </template>
                <template v-else-if="itemGraduatedPricesalableVariationCount">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
                </template>
                <template v-else>
                  {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                </template>
                <template v-if="item.prices.default.contactClassDiscount.amount > 0">
                  <popper v-cloak class="ml-auto your-price">
                    <template #handle>
                      <button class="btn btn-icon btn-secondary btn-sm">
                        <i class="fa fa-info"></i>
                      </button>
                    </template>
                    <template #content>
                      <div>
                        <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value">
                          <div class="crossprice" v-if="item.prices.specialOffer">
                            {{ $translate("Woerner::Template.singlePriceBisher") }} <s>{{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}</s>
                          </div>
                          <div class="crossprice" v-else>
                            {{ $translate("Woerner::Template.singlePriceBisher") }} <s>{{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}</s>
                          </div>
                        </template>
                        <div >
                          {{ $translate("Woerner::Template.singlePriceAktuell") }} {{ item.prices.default.price.value | currency }}
                        </div>
                        <div>
                          {{ $translate("Woerner::Template.singlePriceYourPrice") }} {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}
                        </div>
                      </div>
                    </template>
                  </popper>
                </template>
                <br>
                <span class="text-muted small test">
                  <template v-if="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount">
                    {{ graduatedMwstPrice | currency }}
                  </template>
                  <template v-else>
                    {{ item.prices.default.data.basePriceNet | currency }}
                  </template>
                  {{ $translate("Ceres::Template.itemExclVAT") }}
                </span>
              </div>
            </div>
          </div>
          <slot name="after-prices"></slot>
          <div class="category-lowest-price small" v-if="item.prices.default.lowestPrice.value && hasCrossPrice">
            <span v-html="$translate('Ceres::Template.itemLowestPrice', {'price': item.prices.default.lowestPrice.formatted})"></span>
          </div>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import {getSlotData} from "../helper/getSlotData";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial
  },

  props: {
    decimalCount:
        {
          type: Number,
          default: 0
        },
    imageUrlAccessor:
        {
          type: String,
          default: "urlSecondPreview"
        },
    itemData:
        {
          type: Object
        },
    disableCarouselOnMobile:
        {
          type: Boolean
        },
    paddingClasses:
        {
          type: String,
          default: null
        },
    paddingInlineStyles:
        {
          type: String,
          default: null
        },
    forceUrlWithVariationId:
        {
          type: Boolean,
          default: false
        }
  },

  jsonDataFields: [
    "itemDataRef"
  ],

  computed:
      {
        hundredYears() {
          let current = this?.item;
          if(current?.hasOwnProperty('tags'))
          {
            const tags = current?.tags;
            const hundredYears = tags?.filter(tag => tag.id == 330);
            return (hundredYears?.length > 0);
          }
          return false

        },
        combinedPropertiesString() {
          const targetIds = [331, 422, 427];

          let resultString = '';

          if(this?.item && this?.item.variationProperties && this?.item.variationProperties.length > 0)
          {
            const sortedProperties = this.item.variationProperties
                .filter(prop => targetIds.includes(prop?.property?.id))
                .sort((a, b) => a.property?.id - b.property?.id);


            sortedProperties.forEach((prop, index) => {

              let value = '';

              if (prop.property.id === 422)
              {
                value = prop?.values?.value;
                value += ' LEDs';
              }
              else if (prop.property.id === 427) {
                value = prop?.values?.value ?? prop?.values[1]?.value;
              }
              else{
                value = prop.values?.value;
              }

              if (index > 0) {
                resultString += ' - ';
              }
              resultString += value;
            });

          }

          return resultString;
        },
        catIcons()
        {
          let icons = [];
          if(Object.hasOwnProperty.call(this.item,'variationProperties'))
          {
            for(let i = 0; i < this.item.variationProperties.length; i++)
            {
              if(Object.hasOwnProperty.call(this.item.variationProperties[i],'property'))
              {
                if(this.item.variationProperties[i].property.id === 84)
                {
                  if(typeof this.item.variationProperties[i].values === 'object' &&
                      !Array.isArray(this.item.variationProperties[i].values) &&
                      this.item.variationProperties[i].values !== null)
                  {
                    icons.push(this.item.variationProperties[i].values)
                  }
                  else
                  {
                    for(let i2 = 0; i2 < this.item.variationProperties[i].values.length; i2++)
                    {
                      icons.push(this.item.variationProperties[i].values[i2]);
                    }
                  }
                }
              }
              else
              {
                for(let i3 = 0; i3 < this.item.variationProperties[i].properties.length; i3++)
                {
                  if(this.item.variationProperties[i].properties[i3].id === 84)
                  {
                    if(typeof this.item.variationProperties[i].properties[i3].values === 'object' &&
                        !Array.isArray(this.item.variationProperties[i].properties[i3].values) &&
                        this.item.variationProperties[i].properties[i3].values !== null)
                    {
                      icons.push(this.item.variationProperties[i].properties[i3].values)
                    }
                    else
                    {
                      for(let i4 = 0; i4 < this.item.variationProperties[i].properties[i3].values.length; i4++)
                      {
                        icons.push(this.item.variationProperties[i].properties[i3].values[i4]);
                      }
                    }
                  }
                }
              }
            }
          }
          return icons;
        },
        zulauf()
        {
          let current = this.item;

          let availability          = parseInt(current.variation?.availabilityId);
          let foundTags             = false;
          let textFromProp          = ''
          let estimatedAvailableAt  = current.variation?.estimatedAvailableAt ?? '';

          if(current.hasOwnProperty('tags') && current.tags.length > 0)
          {
            for(let i = 0; i < current.tags.length; i++)
            {
              if(current.tags[i].id === 218 || current.tags[i].id === 220)
              {
                foundTags = true;
              }
            }
          }

          if(current.hasOwnProperty('variationProperties') && current.variationProperties.length > 0)
          {
            for(let i = 0; i < current.variationProperties.length; i++)
            {
              if(current.variationProperties[i].id === 6)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 448)
                  {
                    textFromProp = current.variationProperties[i].properties[i2].values.value;
                  }
                }
              }
            }
          }
          if(availability === 9 && foundTags)
          {
            if(textFromProp !=='')
            {
              return textFromProp;
            }
            else
            {
              return this.$translate("Woerner::Template.deliveryDate");
            }
          }
          if(availability === 9 && foundTags === false)
          {
            if(estimatedAvailableAt !== '')
            {
              let MyDate = new Date(estimatedAvailableAt);
              MyDate.setDate(MyDate.getDate() + 5);

              let deliveryDate = ('0' + MyDate.getDate()).slice(-2)  + '.' + ('0' + (MyDate.getMonth()+1)).slice(-2) + '.' + MyDate.getFullYear();

              let formatet     = this.$translate("Woerner::Template.deliveryDateValue", {"date":deliveryDate});

              return formatet
            }
            else if (textFromProp !== '')
            {
              return textFromProp;
            }
            else
            {
              return this.$translate("Woerner::Template.deliveryDate");
            }
          }
        },
        showVars()
        {
          if(App.currentCategoryId == 2283 )
          {
            return true
          }
          else
          {
            return false
          }
        },
        lang()
        {
          return App.language
        },
        item()
        {
          return this.itemData || this.itemSlotData || this.itemDataRef;
        },

        itemSlotData: getSlotData('item-data'),

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
          return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
          return this.item.texts;
        },

        itemPrice()
        {
          return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },
        basePrice()
        {
          return this.item.prices.default.basePrice;
        },
        graduatedMwstPrice()
        {
          return (this.item.prices.graduatedPrices[0].unitPrice.value /  (this.item.prices.graduatedPrices[0].vat.value/100+1)).toFixed(2);
        },
        itemPriceGraduated()
        {
          let unitPrice;
          if (App.config.item.enableGraduatedPrices) {
            unitPrice = this.item.prices.graduatedPrices.length > 0
                ? this.item.prices.graduatedPrices[0].unitPrice
                : this.item.prices.default.unitPrice;
          } else {
            unitPrice = this.item.prices.default.unitPrice;
          }

          return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemGraduatedPriceisCheapestSorting()
        {

          return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount()
        {
          return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        itemSetPrice()
        {
          return this.$options.filters.currency(
              this.item.prices.default.price.value,
              this.item.prices.default.currency
          );
        },

        urlWithVariationId()
        {
          return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        hasCrossPrice() {
          const hasRrpPrice = !!this.item.prices.rrp &&
              this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

          const hasBeforePrice = !!this.item.prices.specialOffer &&
              !!this.item.prices.default &&
              this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

          return hasRrpPrice || hasBeforePrice;
        },

        ...mapState({
          showNetPrices: state => state.basket.showNetPrices
        })
      }
}
</script>
